export default __webpack_public_path__ + "static/team15-fe2de13b2320dc96bb6275f14c1a5a10.webp";